import { ReactNode } from 'react';
import { useDrop } from 'react-dnd';
import { FloatingWindow } from 'types/app.types';
import styles from './index.module.scss';

const { wrapper } = styles;

interface MapViewLayoutProps {
    children: ReactNode
  }

function MapViewLayout({ children } : MapViewLayoutProps) {
  const [, drop] = useDrop(() => ({
    accept: 'WINDOW',
    drop(item: FloatingWindow, monitor) {
      const delta = monitor.getDifferenceFromInitialOffset() as {
            x: number
            y: number
          };
      return { top: delta.y, left: delta.x };
    },
  }), []);
  return (
    <div
      className={wrapper}
      ref={drop}
    >
      {children}
    </div>
  );
}

export default MapViewLayout;
